import { Navigate, useLocation } from "react-router";

import { Props } from "react-apexcharts";
import { useSelector } from "react-redux";
import { RootState } from "../redux";
import { useEffect } from "react";
import { useAppContext } from "src/layouts/App-Context";
import { navItems } from "src/layouts/full/sidebar/Sidebaritems";

export function PrivateRoute({ children }: Props) {
const location = useLocation();
const  {setRights} = useAppContext()
  const { pathname } = location;
  const { isAuthenticated , permission } = useSelector((state: RootState) => state.user);

  const isAllowed = navItems.find((item) => {
    if (item.url === `/${pathname.split("/")[1]}`) {
      return permission?.[item.permission||""];
    }
    return false;
  });
   useEffect(() => {
    if (isAllowed?.permission) {
      setRights(permission?.[isAllowed?.permission] || { isView: 0, isEdit: 0 });
    }
  }, [isAllowed, permission, setRights]);

  return isAuthenticated && (isAllowed||pathname=="/profile"||pathname=="/dashboard") ? children : <Navigate to={isAuthenticated ?"*"  :"/signin"} replace />;
}